<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'setting'}">
              <a>システム設定</a>
            </router-link>
            <li class="active">照合ログ編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>照合ログ編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label no-padding-right" for="form-field-1">照合ログID</label>
                <div class="col-sm-9">
                  <input type="text" id="form-field-1" placeholder="照合ログID" class="col-xs-10 col-sm-6" v-model="accessLogId" disabled />
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-offset-3 col-md-9"><span id="model_error" class="error_m"></span></div>
                <label class="col-sm-3 control-label no-padding-right" for="form-field-1">ログ名称</label>
                <div class="col-sm-9">
                  <input type="text" id="form-field-1" placeholder="ログ名称" class="col-xs-10 col-sm-6" v-model="configLogInfor.logLabel" v-on:keyup="updateStatus"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-9">
                  <router-link :to="{ name: 'setting'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit" :disabled="notEdit">
                    編集を保存
                  </button>
                  <button class="btn btn-info save_group_bottom" type="button" @click="deleteConfig()" style="background:red!important;border-color: red!important" :disabled="configLogInfor.isDefault">
                    初期化する
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      logConfigData: null,
      configLogInfor: {
        accessLogId: '',
        logLabel: '',
        isDefault: false
      },
      flag: false,
      accessLogId: '',
      message_error: '',
      message_success: '',
      success: false,
      loading: false,
      notEdit: true
    }
  },
  created () {
    var vm = this
    vm.getConfigLogData()
  },
  methods: {
    updateStatus () {
      this.notEdit = false
    },
    deleteConfig () {
      var vm = this
      vm.message_success = ''
      vm.message_error = ''
      this.loading = true
      this.$http.delete(Config.CONFIG_LOG_API + '/' + encodeURIComponent(vm.accessLogId))
        .then(response => {
          vm.message_success = Config.DELETE_CONFIG_LOG_API_SUCCESS
          vm.message_error = ''
          this.loading = false
          vm.getConfigLogData()
        })
        .catch((error) => {
          this.message_error = ''
          if (error.body) {
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.message_error = ''
                } else {
                  this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 403:
                this.message_error = '照合ログマスターの削除権限がありません。'
                break
              case 404:
                this.message_error = '該当するデーターがありません。'
                break
              case 500:
                this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    },
    validateBeforeSubmit () {
      this.flag = true
      if (this.configLogInfor.logLabel === null || this.configLogInfor.logLabel === '') {
        $('#model_error').html('ログ名称は必須です。')
        $('#model').addClass('error')
        this.flag = false
      } else {
        $('#model_error').html('')
        $('#model').removeClass('error')
        this.flag = true
      }
      if (this.flag) {
        this.editInforLog()
      }
    },
    getConfigLogData () {
      var vm = this
      var data = this.$route.query
      vm.accessLogId = data.id
      this.$http.get(Config.CONFIG_LOG_API)
        .then(response => {
          vm.logConfigData = response.body.logConfigs
          vm.logConfigData.forEach(function (item) {
            if (item.accessLogId === vm.accessLogId) {
              vm.configLogInfor.logLabel = item.logLabel
              vm.configLogInfor.isDefault = item.isDefault
              vm.notEdit = item.isDefault
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    editInforLog () {
      var vm = this
      vm.loading = true
      this.message_success = ''
      this.message_error = ''
      const Infor = {
        accessLogId: vm.accessLogId,
        logLabel: vm.configLogInfor.logLabel
      }
      this.$http.post(Config.CONFIG_LOG_API, Infor)
        .then(response => {
          this.loading = false
          this.message_success = Config.EDIT_CONFIG_LOG_API_SUCCESS
          this.message_error = ''
          vm.getConfigLogData()
        })
        .catch((error) => {
          this.message_success = ''
          if (error.body) {
            this.loading = false
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.message_error = ''
                } else {
                  this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.message_error = '照合ログマスターの編集権限がありません。'
                break
              case 404:
                this.message_error = '該当するデーターがありません。'
                break
              case 500:
                this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          } else {
            this.loading = false
            this.message_error = Config.SERVER_CONNECT_ERROR
          }
        })
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/configLogEdit.vue